import React, { useState } from "react";
import { InputText } from "primereact/inputtext";
import { Password } from "primereact/password";
import { Button } from "primereact/button";
import { Message } from "primereact/message";
import { useNavigate } from "react-router-dom";
import { registerQuery } from "../strapi/queries";

import logo from "../assets/logo.png";
import "./RegisterForm.css";

export default function RegisterForm() {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState(null);
  const [successMsg, setSuccessMsg] = useState(null);

  const navigate = useNavigate();
  const { register } = registerQuery();

  const handleRegisterClick = async (e) => {
    e.preventDefault();
    setErrorMsg(null);
    setSuccessMsg(null);
    try {
      const result = await register(username, email, password);
      if (result && result.user) {
        setSuccessMsg("Registrierung erfolgreich! Sie können sich jetzt anmelden.");
        setTimeout(() => {
          navigate('/login');
        }, 2000); // Redirect to login after 2 seconds
      }
    } catch (err) {
      setErrorMsg(err.message || "Registrierung fehlgeschlagen");
    }
  };

  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <div className="register-container">
      <div className="register-card">
        <div className="logo-container">
          <img src={logo} alt="Logo" className="login-logo" />
          <p></p>
        </div>{" "}
        <div className="p-fluid">
          <div className="p-field">
            <InputText
              id="username"
              value={username}
              onChange={(e) => {
                let sanitized = e.target.value.replace(/[^a-zA-Z0-9-_.\s]/g, '');
                if (sanitized.length > 20) {
                  sanitized = sanitized.slice(0, 20);
                }
                setUsername(sanitized)
              }}
              placeholder="Benutzername"
              required
              className="p-inputtext-lg"
            />
          </div>

          <div className="p-field">
            <InputText
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="E-Mail"
              required
              className="p-inputtext-lg"
            />
          </div>

          <div className="p-field">
            <Password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Passwort"
              toggleMask
              feedback={false}
              required
            />
          </div>

          {errorMsg && <Message severity="error" text={errorMsg} />}
          {successMsg && <Message severity="success" text={successMsg} />}
          <p></p>
          <Button
            label="Registrieren"
            icon="pi pi-user-plus"
            type="submit"
            onClick={handleRegisterClick}
            className="p-button-lg p-button-primary"
            block
          />
          <p></p>
          <Button
            label="Zurück zum Login"
            icon="pi pi-sign-in"
            onClick={handleLoginClick}
            className="p-button-lg p-button-secondary"
            block
          />
        </div>
      </div>
    </div>
  );
}